import * as React from 'react';
import { makeStyles, Grid } from '@material-ui/core';
import { WindowSizeContext } from './form/BForm';
var useStyles = makeStyles({
    gridItem: {
        padding: 10
    },
    gridItemNoMarginPadding: {
        padding: 0,
        margin: 0
    }
});
export var BLayout = function (props) {
    var w = props.w, _a = props.big, big = _a === void 0 ? false : _a, _b = props.full, full = _b === void 0 ? false : _b, _c = props.ignoreGrid, ignoreGrid = _c === void 0 ? false : _c, children = props.children, alignComponent = props.alignComponent, _d = props.noMarginPadding, noMarginPadding = _d === void 0 ? false : _d;
    var width = React.useContext(WindowSizeContext)[0];
    var classes = useStyles();
    // consider using window inner width instead of avg ratios
    var xs = w && w !== 0 ? Math.max(1, Math.min(12, Math.floor(w * 4))) : undefined; // math to go from w/minW/etc to # of breakpoints the mui grid
    var sm = w && w !== 0 ? Math.max(1, Math.min(12, Math.floor(w * 3))) : undefined;
    var md = w && w !== 0 ? Math.max(1, Math.min(12, Math.floor(w * 2))) : undefined;
    var lg = w && w !== 0 ? Math.max(1, Math.min(12, Math.floor(w * 1))) : undefined; // might want this to be 1.33? keep tweaking
    var xl = w && w !== 0 ? Math.max(1, Math.min(12, Math.floor(w * 1))) : undefined;
    if (full) {
        xs = 12;
        sm = 12;
        md = 12;
        lg = 12;
        xl = 12;
    }
    if (ignoreGrid) {
        return (React.createElement(React.Fragment, null, children));
    }
    var handleAlignment = function (size) {
        if (big) {
            return (React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: true }),
                React.createElement(Grid, { item: true, xs: size, sm: size, md: size, lg: size, xl: size },
                    React.createElement("div", { id: props.name, className: noMarginPadding ? classes.gridItemNoMarginPadding : classes.gridItem }, children)),
                React.createElement(Grid, { item: true, xs: true })));
        }
        else if (alignComponent === 'center') {
            return (React.createElement(Grid, { container: true, item: true, xs: size, sm: size, md: size, lg: size, xl: size, alignItems: 'center', justify: 'center', direction: 'row' },
                React.createElement("div", { className: noMarginPadding ? classes.gridItemNoMarginPadding : classes.gridItem }, children)));
        }
        else if (alignComponent === 'right') {
            return (React.createElement(Grid, { container: true, item: true, xs: size, sm: size, md: size, lg: size, xl: size, alignItems: 'flex-end', justify: 'flex-end', direction: 'row' },
                React.createElement("div", { className: noMarginPadding ? classes.gridItemNoMarginPadding : classes.gridItem }, children)));
        }
        return undefined;
    };
    if (width && width < 600) {
        var result = handleAlignment(xs);
        return result ? result :
            React.createElement(Grid, { item: true, xs: xs },
                React.createElement("div", { className: noMarginPadding ? classes.gridItemNoMarginPadding : classes.gridItem }, children));
    }
    else if (width && width < 960) {
        var result = handleAlignment(sm);
        return result ? result :
            React.createElement(Grid, { item: true, sm: sm },
                React.createElement("div", { className: noMarginPadding ? classes.gridItemNoMarginPadding : classes.gridItem }, children));
    }
    else if (width && width < 1280) {
        var result = handleAlignment(md);
        return result ? result :
            React.createElement(Grid, { item: true, md: md },
                React.createElement("div", { className: noMarginPadding ? classes.gridItemNoMarginPadding : classes.gridItem }, children));
    }
    else if (width && width < 1920) {
        var result = handleAlignment(lg);
        return result ? result :
            React.createElement(Grid, { item: true, lg: lg },
                React.createElement("div", { className: noMarginPadding ? classes.gridItemNoMarginPadding : classes.gridItem }, children));
    }
    else if (width && width >= 1920) {
        var result = handleAlignment(xl);
        return result ? result :
            React.createElement(Grid, { item: true, xl: xl },
                React.createElement("div", { className: noMarginPadding ? classes.gridItemNoMarginPadding : classes.gridItem }, children));
    }
    return (React.createElement(Grid, { item: true, xs: xs, sm: sm, md: md, lg: lg, xl: xl, component: 'div' },
        React.createElement("div", { className: noMarginPadding ? classes.gridItemNoMarginPadding : classes.gridItem }, children)));
};
//# sourceMappingURL=BLayout.js.map